import { withStyles } from '@material-ui/core/styles';
import styles from './CardDescription.styles';
import CardDescription from './CardDescription';

export default withStyles(styles)(CardDescription);
